import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'mj-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
})
export class DropdownComponent {
  @Input() actions: { label: string; icon?: string }[];
  @Output() action: EventEmitter<any> = new EventEmitter<any>();

  onClick(label: string) {
    this.action.emit(label);
  }
}
